export default {
  required: {
    required: true,
    message: 'Обязательное поле',
  }
}